import { joinClasses } from '../../primitives/fieldClassSlots';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { LayoutNodeChildProps } from '../nodeRenderProps';
import type { IndentNode } from '../types';
import { RenderNodes } from '../renderNodes';

export function Indent({
  node,
  answers,
  repeatBindings,
}: LayoutNodeChildProps<IndentNode>) {
  return (
    <div
      className={joinClasses(
        'mt-4 space-y-6 border-l-2 border-primary/25 pl-5',
        node.className
      )}
      style={layoutInlineStyle(node.style)}
    >
      <RenderNodes
        nodes={node.children}
        answers={answers}
        repeatBindings={repeatBindings}
      />
    </div>
  );
}
